export default __webpack_public_path__ + "static/media/Oro-2.415a141b.png";